var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__header"},_vm._l((_setup.itensHeaders),function(itemHeader){return _c('div',{key:itemHeader.value,staticClass:"c-header__cell"},[_c('div',{staticClass:"c-cell c-cell__text"},[_vm._v(" "+_vm._s(itemHeader.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }